<template>
	<div id="qe_center2">
		<div class="cc-header">评价进度</div>
		<div class="main-value" id="pj_progress"></div>
	</div>
</template>

<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
const echarts = require("echarts");
let evalSpeedChart;
let pageSize = 6; //echarts每页显示数量
export default {
	data() {
		return {
			start: 0,
			end: pageSize - 1,
			total: 0
		};
	},
	mounted() {
		this.initData();
		// 定时器刷新，1小时
		let _this = this;
		setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 60);
		// 定时器轮播，5秒
		setInterval(() => {
			_this.dataZoomAutoScoll();
		}, 1000 * 5);
	},
	methods: {
		//echarts图标数据过多时，x轴自动滑动
		dataZoomAutoScoll() {
			const max = this.total - 1;
			if (pageSize < this.total) {
				if (this.end > max || this.start > max - pageSize) {
					this.start = 0;
					this.end = pageSize - 1;
				} else {
					this.start += 1;
					this.end += 1;
				}
				evalSpeedChart.dispatchAction({
					type: 'dataZoom',
					dataZoomIndex: 0,
					startValue: this.start,
					endValue: this.end
				});
			}
		},
		initData() {
			let _this = this;
			// 基于准备好的dom，初始化echarts实例
			evalSpeedChart = echarts.init(document.getElementById("pj_progress"));
			this.$http.get("/dataView/quality/edu/getEvalSpeed?orgCode=" + orgCode + "&termName=" + _this.$parent.$parent.$parent.termName).then(res => {
				if (res.data.code === 200) {
					var result = res.data.result;
					_this.total = result.xDatas.length;

					var xData = [];
					var yData1 = [];
					var yData2 = [];
					var yData3= [];
					for (var i = 0; i < result.xDatas.length; i++) {
						xData.push(result.xDatas[i]);
						yData1.push(result.ydatas1[i]);
						if (result.ydatas2[i] > result.ydatas1[i]) {
							yData2.push(result.ydatas1[i]);
						} else {
							yData2.push(result.ydatas2[i]);
						}
						if (result.ydatas3[i] < 0) {
							yData3.push(0);
						} else {
							yData3.push(result.ydatas3[i]);
						}
					}

					var option = {
						tooltip: {
							trigger: 'axis',
							formatter: function (params) {
								var relVal = params[0].name;
								for (var i = 0; i < params.length; i++) {
									relVal += '<br/>' + params[i].marker + '&nbsp;' + params[i].seriesName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>' + params[i].value + '人</b>';
								}
								return relVal
							}
						},
						dataZoom: [{
							type: 'inside',
							startValue: _this.start,
							endValue: _this.end,
						}],
						legend: {
							top: 0,
							right: 35,
							icon: 'roundRect',
							textStyle: {
								fontSize: fontSize(0.15),
								height: 13,
								rich: {
									a: {
										verticalAlign: 'middle'
									}
								},
								color: '#54beff' // 把颜色这里做成函数就可以了
							},
							itemWidth: 20,
							itemHeight: 10
						},
						xAxis: [{
							type: 'category',
							scale: true,
							data: xData,
							boundaryGap: true,
							axisLabel: {
								interval: 0,
								rotate: 25, // 角度
								formatter: function (value) {
									return (value.length > 6 ? (value.slice(0, 6) + "...") : value)
								},
								textStyle: {
									color: '#54beff',
									fontSize: fontSize(0.13)
								}
							}
						}],
						grid: {
							left: "8%",
							top: "20%",
							bottom: "25%",
						},
						yAxis: [{
							type: 'value',
							splitLine: {
								show: true,
								lineStyle: {
									width: 1,
									color: 'rgba(255, 255, 255, 0.2)',
								}
							},
							axisLabel: {
								textStyle: {
									color: '#54beff',
									fontSize: fontSize(0.12)
								}
							},
							axisLine: {
								show: true
							},
						}],
						series: [{
							name: '参与学生数',
							type: 'line',
							stack: 'Total',
							smooth: true,
							lineStyle: {
								width: 0
							},
							showSymbol: false,
							areaStyle: {
								opacity: 0.8,
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: 'rgb(0, 221, 255)'
								},
								{
									offset: 1,
									color: 'rgb(77, 119, 255)'
								}
								])
							},
							emphasis: {
								focus: 'series'
							},
							data: yData1
						},
						{
							name: '已评价学生数',
							type: 'line',
							stack: 'Total',
							smooth: true,
							lineStyle: {
								width: 0
							},
							showSymbol: false,
							areaStyle: {
								opacity: 0.8,
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: 'rgb(55, 162, 255)'
								},
								{
									offset: 1,
									color: 'rgb(116, 21, 219)'
								}
								])
							},
							emphasis: {
								focus: 'series'
							},
							data: yData2
						},
						{
							name: '未评价学生数',
							type: 'line',
							stack: 'Total',
							smooth: true,
							lineStyle: {
								width: 0
							},
							showSymbol: false,
							label: {
								show: true,
								position: 'top'
							},
							areaStyle: {
								opacity: 0.8,
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: 'rgb(255, 191, 0)'
								},
								{
									offset: 1,
									color: 'rgb(224, 62, 76)'
								}
								])
							},
							emphasis: {
								focus: 'series'
							},
							data: yData3
						}
						]
					};
					evalSpeedChart.setOption(option);
					// 响应式变化
					window.addEventListener("resize", () => evalSpeedChart.resize(), false);
				}
			});
		}
	},
	destroyed() {
		window.onresize = null;
	}
};

function fontSize(res) {
	let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	if (!clientWidth) return;
	let fontSize = 100 * (clientWidth / 1920);
	return res * fontSize;
}
</script>

<style lang="scss">
#qe_center2 {
	height: 100%;
	padding: 0 0 0 3%;

	.cc-header {
		width: 100%;
		padding-top: 0.25rem;
		color: #55ffff;
		font-size: 0.25rem;
	}

	.main-value {
		width: 100%;
		height: 90%;
		margin-top: -0.25rem;
	}

}
</style>